import {defineStore} from 'pinia'

export const useUserStore = defineStore('userStore', () => {
    const firstName = ref<string>('')
    const lastName = ref<string>('')
    const uid = ref<string>('')
    const isAdmin = ref<boolean>(false)


    const getInitials = () => (firstName.value[0] ?? '') + (lastName.value[0] ?? '')
    const getDisplayName = () => `${firstName.value[0]}. ${lastName.value}`

    return {firstName, lastName, getInitials, getDisplayName, uid, isAdmin}
}, {persist: {pick: ['firstName', 'lastName', 'uid', 'isAdmin']}})
